import { Dialog, DialogTitle, DialogContent, DialogActions, Stack } from "@mui/material"
import FormButtons from "../Inputs/FormButtons"

export default function ModalForm({title, children, open, onSubmit, onClose, loading}){
    
    return <Dialog open={open} onClose={onClose}>

        <DialogTitle>{title || 'Formulaire'}</DialogTitle>

        <form onSubmit={onSubmit}>

            <DialogContent>

                <Stack direction='column' spacing={2} width={window.screen.width < 800 ? 320 : 400}>

                    {children}
                
                </Stack>

                <DialogActions sx={{mt: 2}}>
                    
                    <FormButtons
                        loading={loading}
                        onCancel={onClose}
                    />

                </DialogActions>

            </DialogContent>

        </form>

    </Dialog>


}